<template>
  <div class='container-fluid'>
    <div class='row'>
      <div class='col d-none d-sm-block'></div>
      <div id='stepBody' class='col-12 col-10-sm col-md-8' role="main">
          <stepheader-view/>
          <router-view/>
          <bottomnav-view/>
      </div>
      <div class='col d-none d-sm-block'></div>
    </div>
  </div>
</template>

<script>
export default {
  updated() {
    this.formatStepBody();
  },
  mounted() {
    this.formatStepBody();
  },
  methods: {
    formatStepBody() {
      if (this.$route.meta.page === 8) {
        document.getElementById("stepHeader").classList.add("text-center");
        document.getElementById("stepBody").classList.remove("col-lg-8");
        // document.getElementById("stepBody").classList.remove("col-xl-7");
      } else {
        document.getElementById("stepBody").classList.add("col-lg-8");
        // document.getElementById("stepBody").classList.add("col-xl-7");
        document.getElementById("stepHeader").classList.remove("text-center");
      }
    }
  }
};
</script>